export type SelectionActionBarItemCountState = {
  selectedItemCount: number;
  showSelectionDropdown: boolean;
};

export const getSelectionActionBarItemCountState = ({
  hasOnlyCanvasesSelected,
  selectAll,
  selectedItemCount,
}: {
  hasOnlyCanvasesSelected: boolean;
  selectAll: boolean;
  selectedItemCount: number;
}): SelectionActionBarItemCountState => ({
  selectedItemCount,
  showSelectionDropdown: !selectAll && !hasOnlyCanvasesSelected,
});
